<form [formGroup]="form" (submit)="onSave()" class="max-w-full" autocomplete="off">
  <div class="formgrid grid p-fluid w-30rem max-w-screen">
    <div class="field mb-4 col-12">
      <label for="name" class="font-medium text-900">{{'LABEL.NAME' | translate}}</label>
      <input type="text" pInputText id="name" formControlName="name"
        [ngClass]="{'ng-invalid ng-dirty' : isControlValid('name')}" autofocus />
    </div>
  </div>
  <div class="flex justify-content-end w-100">
    <button type="button" pButton pRipple [label]="'BUTTON.CANCEL' | translate" icon="pi pi-times" class="p-button-text p-button-secondary"
      (click)="onCancel()"></button>
    <button pButton pRipple [label]="'BUTTON.SAVE' | translate" icon="pi pi-check" class="p-button-text"></button>

  </div>
</form>
